export { wrapRootElement } from './wrapRootElement';

export const onRouteUpdate = ({ location }) => {
    const paq = window._paq || [];
    window._paq = paq;
    paq.push(['setCustomUrl', location && location.pathname + location.search + location.hash]);
    paq.push(['trackPageView']);
};
